import {
  initPeriodFinancialSheetTree,
  setCurrentNavPage,
  setFilterBusinessUnit,
  setFilterClient,
  setFilterClientGroup,
  setFilterCluster,
  setFilterCollaborators,
  setFilterSquads,
  setFilterYear,
  setSubMenuDirection,
  setSubMenuDirectionToggle
} from "Actions";
import { HORIZONTAL, PAGES, VERTICAL } from "Config";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { selectLoggedAs } from "Selectors";
import {
  fetchParameterSettings,
  fetchPartners,
  fetchPeriodFinancialSheet,
  fetchCollaborator
} from "Thunks";
import PeriodFinancialSheetTree from "./PeriodFinancialSheetTree";
import { parsePreference } from "Utils";

class PeriodFinancialSheetPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen };
  }

  componentDidMount() {
    const {
      dispatch,
      subMenuDirection,
      currentOrganization,
      user
    } = this.props;

    const preferences =
      currentOrganization["authorisation"] &&
      currentOrganization["authorisation"].preferences;

    dispatch(
      fetchCollaborator(
        user.id,
        user.uid,
        user.adminisId ? user.adminisId.split(":")[1] : null
      )
    );

    dispatch(fetchPartners());

    dispatch(setCurrentNavPage(PAGES.FINANCIAL_SHEET_PAGE));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(false));

    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });

    dispatch(setFilterYear(new Date().getFullYear().toString()));

    dispatch(initPeriodFinancialSheetTree());
    if (
      parsePreference(preferences.financial).financialState.allowViewDataBy ===
      1
    ) {
      setTimeout(() => {
        dispatch(fetchPeriodFinancialSheet());
      }, 100);
    }
    dispatch(fetchParameterSettings(new Date().getFullYear().toString()));
  }

  componentDidUpdate(prevProps) {
    const { dispatch, currentOrganization, collaborator } = this.props;
    if (prevProps.collaborator !== collaborator) {
      const preferences =
        currentOrganization["authorisation"] &&
        currentOrganization["authorisation"].preferences;

      dispatch(
        setFilterCollaborators(
          [10, 100, 101, 110].includes(
            parsePreference(preferences.financial).financialState
              .allowViewDataBy
          ) && collaborator
            ? [
                {
                  label: collaborator.name,
                  value: collaborator.id,
                  partner: collaborator.partner.value,
                  color: "#000000",
                  isActif: true
                }
              ]
            : []
        )
      );
      setTimeout(() => {
        dispatch(fetchPeriodFinancialSheet());
      }, 100);
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
    dispatch(setFilterCollaborators([]));
    dispatch(setFilterClient([]));
    dispatch(setFilterSquads([]));
    dispatch(setFilterCluster([]));
    dispatch(setFilterBusinessUnit([]));
    dispatch(setFilterClientGroup([]));
    dispatch(setFilterYear([]));
  }

  render() {
    return (
      <div className={`page-content`}>
        <PeriodFinancialSheetTree uen={this.state.organizationUen} />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  financialSheetFilter: state.financialSheet.periodFilter,
  organization: state.timeSheet.organization,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization,
  collaborator: state.collaborator.collaborator,
  partners: state.auth.partnerOptions,
  user: state.auth.user,
  loggedAs: selectLoggedAs(state),
  spaceAs: state.auth.spaceAs
});

export default connect(mapStateToProps)(PeriodFinancialSheetPage);



// WEBPACK FOOTER //
// ./src/components/Financial/PeriodFinancialPage.js